<template>
  <el-select
    v-bind="$attrs"
    :value="innerValue"
    :disabled="disabled"
    :filterable="filterable||allowCreate"
    :allow-create="allowCreate"
    v-on="$listeners"
  >
    <el-option v-for="(item,index) in options" :key="index" :label="item[labelField]" :value="item[valueField]" />
  </el-select>
</template>

<script>
export default {
  name: 'CargoRequireSelect',
  props: {
    value: { type: [String, Number, Boolean], required: true },
    disabled: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    options: { type: Array, required: true },
    labelField: { type: String, required: true },
    valueField: { type: String, required: true }
  },
  data() {
    return {
      innerValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.matchValue()
      }
    },
    disabled(newVal) {
      if (!newVal && this.innerValue !== this.value) {
        this.$emit('input', this.innerValue)
      }
    },
    allowCreate() {
      this.matchValue()
    },
    options() {
      this.matchValue()
    },
    valueField() {
      this.matchValue()
    }
  },
  methods: {
    // 为空的情况下，显示第一条记录
    matchValue() {
      if (this.value !== '' || this.options.length === 0) {
        this.innerValue = this.value
        return
      }
      this.innerValue = this.options[0][this.valueField]
      if (!this.disabled) {
        this.$emit('input', this.innerValue)
      }
    }
  }
}
</script>
